import { useHistory } from "react-router-dom";
import images from "../../../../utilities/images/images";
import "./FreeBenifits.css";

const FreeBenefits = ({ freeBenefits }) => {
  const data =
    Array.isArray(freeBenefits) && freeBenefits.length > 0 ? freeBenefits : [];

  const history = useHistory();

  // Function to map benefit data to a tab value
  const getTabFromBenefit = (benefit) => {
    const { module, text } = benefit;

    // Mapping logic based on module and text
    if (module === "Practice") {
      if (text === "Previous Year Questions") return "pyq";
      if (text === "Question Bank") return "cps";
    }
    if (module === "Doubt" && text === "Scan Your Doubt") {
      return "exam";
    }

    // Default tab if no match is found
    return "pyq";
  };

  return (
    <div className="container">
      <div className="container-benefits">
        <div className="header">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <h1>Motion Free Benefits</h1>
              <p>Unlimited Access</p>
            </div>
            <div className="gift-icon-benefits">
              <img
                style={{ width: "62px", height: "69px" }}
                src={images.freeGift}
                alt="free_gift"
              />
            </div>
          </div>
          <div className="cards-container">
            {data.map((benefit, index) => (
              <div
                key={index}
                className="benefit-card"
                onClick={() =>
                  history.push({
                    pathname: benefit.url,
                    state: { tab: getTabFromBenefit(benefit) }, // Use the mapped tab
                  })
                }
              >
                <div className="card-content">
                  <div>
                    <span className="card-label">{benefit.module}</span>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <span className="card-text">{benefit.text}</span>
                      <img
                        style={{
                          width: "12px",
                          height: "10px",
                          marginLeft: "10px",
                        }}
                        alt="right_arrow"
                        src={images.userTrialRightIcon}
                      />
                    </div>
                    <div>
                      <img
                        style={{ width: "50px", height: "50px" }}
                        className="card-icon"
                        src={benefit.icon}
                        alt={`${benefit.text} icon`}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeBenefits;
